<div class="p-3">
    <div class="flex justify-content-center my-2">
        <label for="dropdownSelect" style="margin: 0.6%;"><span class="fontStyle">MDM Topic Selection : </span></label>
        <p-dropdown id="dropdownSelect" placeholder="Select an option" [options]="dropdownOptions" filter="true" 
                    optionLabel="label" optionValue="value" filterBy="label" [(ngModel)]="selectedOption"
                    (onChange)="onDropdownChange($event)">
        </p-dropdown>
    </div>

    <ng-container *ngIf="selectedOption === 'Business Areas'">
        <app-crud-table [masterLists]="businessAreas" [tableCols]="baCols" [title]="baTitle"
            [masterListType]="baType"></app-crud-table>
    </ng-container>

    <ng-container *ngIf="selectedOption === 'Labs'">
        <app-crud-table [masterLists]="labs" [tableCols]="labCols" [title]="labTitle" [baOptions]="baOptions"
            [masterListType]="labType" [countries]="countries"></app-crud-table>
    </ng-container>

    <ng-container *ngIf="selectedOption === 'Machine Types'">
        <app-crud-table [masterLists]="machineTypes" [tableCols]="machineTypesCols" [title]="machineTypesTitle"
            [checkSelectedLab]="selectedLab" [masterListType]="machineTypeList" [labOptions]="labOptions">
        </app-crud-table>
    </ng-container>

    <ng-container *ngIf="selectedOption === 'Machines'">
        <app-crud-table [masterLists]="machines" [tableCols]="machineCols" [machineTypesOptions]="machineTypesOptions"
            [title]="machineTitle" [checkSelectedLab]="selectedLab" [labOptions]="labOptions"
            [masterListType]="machineType"></app-crud-table>
    </ng-container>
    <ng-container *ngIf="selectedOption === 'Printers'">
        <app-crud-table [masterLists]="printers" [tableCols]="printerCols" [title]="printerTitle"
            [labOptions]="labOptions" [masterListType]="printerType"></app-crud-table>
    </ng-container>
    <ng-container *ngIf="selectedOption === 'Barcode Templates'">
        <app-barcode-template [masterLists]="templates" [barcodeTemplateHeaders]="templateCols" [title]="templateTitle"
            [labOptions]="labOptions"></app-barcode-template>
    </ng-container>
    <ng-container *ngIf="selectedOption === 'MA Senders'">
        <app-masenders-template [masterLists]="masenders" [tableCols]="masenderCols" [title]="masenderTitle"
            [checkSelectedLab]="selectedLab" [senderDetailCols]="masenderDetailCols"
            [labOptions]="labOptions"></app-masenders-template>
    </ng-container>
    <ng-container *ngIf="selectedOption === 'Kits'">
        <app-kits-template [masterLists]="kits" [kitHeaders]="kitCols" [title]="kitsTitle" [detailCols]="kitDetailCols"
            [checkSelectedLab]="selectedLab" [labOptions]="labOptions">
        </app-kits-template>
    </ng-container>
    <ng-container *ngIf="selectedOption === 'Machine Manufacturer'">
        <app-manufacturer-config [tableCols]="manufacturerConfigCols" [masterLists]="manufacturersList"
            [title]="manufacturerConfigTitle" [selectedLab]="selectedLab"></app-manufacturer-config>
    </ng-container>
    <ng-container *ngIf="selectedOption === 'Redo Reason'">
        <app-redo-reasons [masterLists]="redoReasons" [redoReasonHeaders]="redoReasonCols" [title]="redoReasonTitle"
            [labOptions]="labOptions" [selectedLab]="selectedLab">
        </app-redo-reasons>
    </ng-container>
    <ng-container *ngIf="selectedOption === 'Inbound File Processing'">
        <app-inbound-file-processing [masterLists]="inboundFileProcessing"
            [fileProcessingHeaders]="inboundFileProcessingCols" [title]="inboundFileProcessingTitle"
            [labOptions]="labOptions" [selectedLab]="selectedLab">
        </app-inbound-file-processing>
    </ng-container>
    <ng-container *ngIf="selectedOption === 'Work Flow'">
        <app-work-flow [masterLists]="workFlow" [workFlowHeaders]="workFlowCols" [title]="workFlowTitle"
            [checkSelectedLab]="selectedLab" [labOptions]="labOptions">
        </app-work-flow>
    </ng-container>
    <ng-container *ngIf="selectedOption === 'Control'">
        <app-mdm-controls [masterLists]="controls" [controlHeaders]="controlProcessingCols" [title]="controlTitle"
            [checkSelectedLab]="selectedLab" [labOptions]="labOptions">
        </app-mdm-controls>
    </ng-container>
    <ng-container *ngIf="selectedOption === 'Chemical'">
        <app-chemical [masterLists]="chemical" [chemicalHeaders]="chemicalCols" [title]="chemicalTitle"
            [checkSelectedLab]="selectedLab" [labOptions]="labOptions">
        </app-chemical>
    </ng-container>
    <ng-container *ngIf="selectedOption === 'Senders'">
        <app-senders-template [masterLists]="senders" [tableCols]="senderCols" [title]="senderTitle"
            [checkSelectedLab]="selectedLab" [labOptions]="labOptions" [loading]="loading"></app-senders-template>
    </ng-container>
    <ng-container *ngIf="selectedOption === 'Tag System'">
        <app-mdm-tag-system [masterLists]="tagSystem" [tableCols]="tagSystemCols" [title]="tagSystemTitle"
            [checkSelectedLab]="selectedLab" [labOptions]="labOptions" [tagSystems]="tagSystems" [loading]="loading">
        </app-mdm-tag-system>
    </ng-container>
    <ng-container *ngIf="selectedOption === 'Tag Plates'">
        <app-tags [masterLists]="tags" [tableCols]="tagCols" [title]="tagsTitle" [checkSelectedLab]="selectedLab"
            [labOptions]="labOptions" [tagPlates]="tagPlates" [loading]="loading"></app-tags>
    </ng-container>
    <ng-container *ngIf="selectedOption === 'Flow Cells'">
        <app-mdm-flowcell [masterLists]="flowCell" [tableCols]="flowCellCols" [title]="flowCellTitle"
            [checkSelectedLab]="selectedLab" [labOptions]="labOptions"></app-mdm-flowcell>
    </ng-container>
    <ng-container *ngIf="selectedOption === 'Analysis'">
        <app-mdm-analysis [masterLists]="analysis" [tableCols]="analysisCols" [title]="analysisTitle"
            [checkSelectedLab]="selectedLab" [labOptions]="labOptions"></app-mdm-analysis>
    </ng-container>
    <ng-container *ngIf="selectedOption === 'Products'">
        <app-crud-table [masterLists]="products" [tableCols]="productCols" [sitConfigOptions]="sitConfigOptions"
            [tagSystemOptions]="tagSystem" [title]="productTitle" [workFlows]="workFlowNGS" [sitConfigs]="sitConfigs"
            [labOptions]="labOptions" [masterListType]="productType"> </app-crud-table>
    </ng-container>
    <ng-container *ngIf="selectedOption === 'Work Flow NGS'">
        <app-app-workflow-ngs [masterLists]="workFlowNGS" [workFlowHeaders]="workFlowNGSCols" [title]="workFlowNGSTitle"
        [checkSelectedLab]="selectedLab" [labOptions]="labOptions"></app-app-workflow-ngs>
    </ng-container>
    <ng-container *ngIf="selectedOption === 'Sales Item Types'">
        <app-crud-table [masterLists]="sitConfigs" [tableCols]="sitConfigCols" [title]="sitConfigTitle"
            [checkSelectedLab]="selectedLab" [labOptions]="labOptions" [masterListType]="sitConfigType" 
            [maxRedoValues]="maxRedoValues" [bmsProductNames]="bmsProductNames"></app-crud-table>
    </ng-container>
    <ng-container *ngIf="selectedOption === 'Process Flow'">
        <app-mdm-processflow [masterLists]="processFlows" [tableCols]="processFlowCols" [title]="processFlowTitle"
            [checkSelectedLab]="selectedLab" [labOptions]="labOptions" [loading]="loading"></app-mdm-processflow>
    </ng-container>

    <ng-container *ngIf="selectedOption === 'Project'">
        <app-crud-table [masterLists]="projects" [tableCols]="projectCols" [title]="projectTitle"
            [checkSelectedLab]="selectedLab" [labOptions]="labOptions"></app-crud-table>
    </ng-container>

    <ng-container *ngIf="selectedOption === 'Project Workflows'">
        <app-crud-table [masterLists]="projectWorkflows" [tableCols]="projectWorkflowCols" [title]="projectWorkflowTitle"
            [checkSelectedLab]="selectedLab" [labOptions]="labOptions"></app-crud-table>
    </ng-container>
</div>